export const introductionCopy = `

# Gator Text

## Gator Text is Amazing!

Win at Text Marketing!

`;